import React, { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createFaQ } from "services/faqService";
import Dropdown from "components/CustomDropdown/Dropdown";

function AddFAQ() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    FaQType: "",
    question: "",
    answer: "",
    isPlanFaQ: false,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.FaQType || !formData.question || !formData.answer) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);
    try {
      const response = await createFaQ(formData);
      if (response.success) {
        toast.success(response.message || "FAQ created successfully!");
        navigate("/faq");
      }
    } catch (error) {
      console.error("Error creating FAQ:", error);
      toast.error(error.message || "Failed to create FAQ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Card>
          <ArgonBox p={3}>
            <ArgonBox mb={3} display="flex" justifyContent="space-between" alignItems="center">
              <ArgonTypography variant="h5" fontWeight="medium">
                Add New FAQ
              </ArgonTypography>
              <ArgonButton
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => navigate("/faq")}
              >
                Back to List
              </ArgonButton>
            </ArgonBox>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {/* FAQ Type */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                    FAQ Type *
                  </ArgonTypography>
                  <Dropdown
                    value={formData.FaQType}
                    options={[
                      { label: "Select FAQ Type", value: "" },
                      { label: "Parent", value: "PARENT" },
                      { label: "Tutor", value: "TUTOR" },
                    ]}
                    onChange={(e) => setFormData({ ...formData, FaQType: e.target.value })}
                    width={300}
                    size="small"
                  />
                </Grid>

                <Grid item xs={12} md={6} display="flex" alignItems="flex-end">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.isPlanFaQ}
                        onChange={(e) =>
                          setFormData({ ...formData, isPlanFaQ: e.target.checked })
                        }
                        color="primary"
                      />
                    }
                    label="Show in Plan FAQ"
                  />
                </Grid>
                {/* Question */}
                <Grid item xs={12}>
                  <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                    Question *
                  </ArgonTypography>
                  <ArgonInput
                    fullWidth
                    name="question"
                    value={formData.question}
                    onChange={handleChange}
                    placeholder="Enter question"
                    multiline
                    rows={3}
                  />
                </Grid>

                {/* Answer */}
                <Grid item xs={12}>
                  <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                    Answer *
                  </ArgonTypography>
                  <ArgonInput
                    fullWidth
                    name="answer"
                    value={formData.answer}
                    onChange={handleChange}
                    placeholder="Enter answer"
                    multiline
                    rows={5}
                  />
                </Grid>
              </Grid>

              {/* Action Buttons */}
              <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={4}>
                <ArgonButton
                  variant="outlined"
                  color="secondary"
                  onClick={() => navigate("/faq")}
                  disabled={loading}
                >
                  Cancel
                </ArgonButton>
                <ArgonButton type="submit" variant="gradient" color="info" disabled={loading}>
                  {loading ? "Creating..." : "Create FAQ"}
                </ArgonButton>
              </ArgonBox>
            </form>
          </ArgonBox>
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddFAQ;
